enum RecordStatus {
	COMPLETE = 'Complete',
	IN_THE_WORKS = 'In The Works',
}

export default RecordStatus;